module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', [_c('h1', {
    staticClass: "fmtitle1",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vii",
      "title": "vii"
    }
  }, [_vm._v("Other “British” titles from")])]), _vm._v(" "), _c('figure', [_c('div', {
    staticClass: "image3"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pgvii.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "fmt"
  }, [_c('span', {
    staticClass: "un"
  }, [_vm._v("MICHAEL DAVID ANTHONY")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('i', [_vm._v("The Becket Factor")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('i', [_vm._v("Midnight Come")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('i', [_vm._v("Dark Provenance")])]), _vm._v(" "), _c('p', {
    staticClass: "fmt"
  }, [_c('span', {
    staticClass: "un"
  }, [_vm._v("ROBERT BARNARD")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('i', [_vm._v("Corpse in a Gilded Cage")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('i', [_vm._v("Death and the Chaste Apprentice")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('i', [_vm._v("The Skeleton in the Grass")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('i', [_vm._v("Out of the Blackout")])]), _vm._v(" "), _c('p', {
    staticClass: "fmt"
  }, [_c('span', {
    staticClass: "un"
  }, [_vm._v("SIMON BRETT")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('i', [_vm._v("Blotto, Twinks and the Ex-King’s Daughter")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('i', [_vm._v("Blotto, Twinks and the Dead Dowager Duchess")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('i', [_vm._v("Blotto, Twinks and the Rodents of the Riviera")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('i', [_vm._v("Blotto, Twinks and the Bootlegger’s Moll")])]), _vm._v(" "), _c('p', {
    staticClass: "fmt"
  }, [_c('span', {
    staticClass: "un"
  }, [_vm._v("CAROLINE GRAHAM")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('i', [_vm._v("The Killings at Badger’s Drift")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('i', [_vm._v("Death of a Hollow Man")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('i', [_vm._v("Death in Disguise")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('i', [_vm._v("Written in Blood")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('i', [_vm._v("Murder at Madingley Grange")])]), _vm._v(" "), _c('p', {
    staticClass: "fmt"
  }, [_c('span', {
    staticClass: "un"
  }, [_vm._v("ELIZABETH IRONSIDE")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('i', [_vm._v("The Accomplice")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('i', [_vm._v("The Art of Deception")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('i', [_vm._v("Death in the Garden")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('i', [_vm._v("A Very Private Enterprise")])]), _vm._v(" "), _c('p', {
    staticClass: "fmt"
  }, [_c('span', {
    staticClass: "un"
  }, [_vm._v("MAGGIE JOEL")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('i', [_vm._v("The Second-Last Woman in England")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('i', [_vm._v("The Past and Other Lies")])]), _vm._v(" "), _c('p', {
    staticClass: "fmt"
  }, [_c('span', {
    staticClass: "un"
  }, [_vm._v("SHEILA RADLEY")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('i', [_vm._v("Death in the Morning")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('i', [_vm._v("The Chief Inspector’s Daughter")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('i', [_vm._v("A Talent for Destruction")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('i', [_vm._v("Fate Worse than Death")])]), _vm._v(" "), _c('p', {
    staticClass: "fmt"
  }, [_c('span', {
    staticClass: "un"
  }, [_vm._v("LESLIE THOMAS")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('i', [_vm._v("Dangerous Davies: The Last Detective")])]), _vm._v(" "), _c('p', {
    staticClass: "fmt"
  }, [_c('span', {
    staticClass: "un"
  }, [_vm._v("L.C. TYLER")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('i', [_vm._v("The Herring Seller’s Apprentice")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('i', [_vm._v("Ten Little Herrings")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('i', [_vm._v("The Herring in the Library")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('i', [_vm._v("Herring on the Nile")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('i', [_vm._v("Crooked Herring")])]), _vm._v(" "), _c('p', {
    staticClass: "pbreak"
  }), _c('p'), _vm._v(" "), _c('p'), _vm._v(" "), _c('figure', [_c('div', {
    staticClass: "image"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_ix",
      "title": "ix"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pgi.png"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d2c332e0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/08_Fm03.vue
// module id = 78
// module chunks = 0